<script setup lang="ts">
import { useI18n } from 'vue-i18n'

withDefaults(
  defineProps<{
    title: string
    icon: string
    locked?: boolean
    lockedText?: string
    flush?: boolean
  }>(),
  {
    locked: false,
    flush: false,
  },
)

const { t } = useI18n()

const flushPassThrough = {
  body: { class: 'px-0! pb-0!' },
  caption: { class: 'px-[var(--p-card-body-padding)]' },
}
</script>

<template>
  <Card class="shadow-card!" :class="{ 'overflow-hidden': flush }" :pt="flush ? flushPassThrough : undefined">
    <template #title>
      <div class="flex items-center justify-between gap-3 pb-1">
        <div class="flex items-center gap-3">
          <i :class="icon" class="text-ink-3 text-2xl!" aria-hidden="true" />
          <span>{{ title }}</span>
        </div>
        <div v-if="$slots.actions" class="flex items-center gap-2">
          <slot name="actions" />
        </div>
      </div>
    </template>

    <template #content>
      <div class="relative">
        <div :inert="locked" :class="{ 'pointer-events-none blur-sm select-none': locked }">
          <slot />
        </div>

        <div
          v-if="locked"
          role="status"
          class="bg-surface/70 absolute inset-0 flex items-center justify-center rounded p-6 backdrop-blur-[1px]">
          <div class="flex flex-col items-center gap-3 text-center">
            <span class="bg-success-50 text-success-800 flex size-12 items-center justify-center rounded-full">
              <i class="pi pi-lock text-xl!" aria-hidden="true" />
            </span>
            <p class="text-ink max-w-48 text-sm font-semibold">
              {{ lockedText ?? t('lockedText') }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </Card>
</template>

<i18n>
{
  "de": {
    "lockedText": "Stelle einen Antrag, um mehr zu sehen"
  },
  "en": {
    "lockedText": "Submit a request to see more"
  }
}
</i18n>
